import { Image, Flex } from "@chakra-ui/react";
import "./styles/loader.css";

export const Histogram = () => (
  <Image maxW="30" src="images/histogram.svg"/>
)

export const Rewards = () => (
  <Image maxW="30" src="images/reward.svg"/>
)

export const Swap = () => (
  <Image maxW="30" src="images/swap.svg"/>
)


export const ComingSoon = () => (
  <Image maxW="30" src="images/comingSoon.svg"/>
)

export const LoadingIcon = () => (
  <Flex h="50vh" justifyContent="center">
    <Image className="loader" maxW="100" src="images/logoNoText.svg"/>
  </Flex>

)